// extracted by mini-css-extract-plugin
export default {"input":"editBoardName_input__URr-D"};